import styled from "styled-components";
import { animated } from "@react-spring/web";
import { motion } from "framer-motion";
import Button from "components/Buttons/ThemeButton";
import { LoyaltyPointsV2 } from "styles/general_styles";
//import { styled : styledMui } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const Container = styled.div<{
	image?: string;
	isFirstNode?: boolean;
	lockedImage?: string;
}>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	position: relative;
	width: 100%;
	height: 100%;
	background-image: url(${(props) => props.image});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	&:not(.several-nodes) {
		font-size: 0.96em;
	}

	&.several-nodes {
		//height: 96%;
		z-index: ${(props) => (props.isFirstNode ? 6 : 2)};
	}

	@media (min-width: 734px) {
		&:not(.several-nodes) {
			font-size: 1em;
		}

		background-position-x: center;
		background-position-y: unset;
		//background-size: auto 94%;
		height: 100%;
		width: 100%;

		&.several-nodes {
			background-size: 100% auto;
			z-index: unset;
		}
	}

	::after {
		content: "";
		position: absolute;
		inset: 0;
		background-image: url(${(props) => props.lockedImage});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		z-index: 0;
		width: 100%;
		height: 100%;

		@media (min-width: 734px) {
			background-position-x: center;
			background-position-y: unset;
			//background-size: auto 94%;

			&.several-nodes {
				background-size: 100% auto;
				z-index: unset;
			}
		}
	}
`;

export const CardHeader = styled.div`
	height: 26%;
	width: 100%;
	display: flex;
	justify-content: end;
	align-items: center;
	flex-direction: column;

	&.several-nodes {
		height: 25%;
	}

	@media (min-width: 734px) {
		height: 36%;
		max-height: unset;

		&.several-nodes {
			height: 35%;
		}
	}
`;

export const Ribbon = styled.div<{ image?: string; isSuperOffer?: boolean }>`
	position: relative;
	top: -14%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-image: url(${(props) => props.image});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	width: 100%;
	color: ${(props) => (props.isSuperOffer ? "#fff" : "#FFEE6F")};
	z-index: 2;

	-webkit-text-stroke-width: 0.18em;
	-webkit-text-stroke-color: #333;
	text-shadow: 0.02em 0.02em #000;
	font-weight: 400;
	font-family: Baloo;
	font-style: normal;
	font-size: 1.4em;

	&.several-nodes {
		top: -3%;
		font-size: 1.4em;
	}

	@media (min-width: 734px) {
		position: relative;
		top: -5%;
		line-height: 100%;
		height: 58%;
		width: 120%;
		font-size: 1.7em;

		&.several-nodes {
			position: unset;
			top: unset;
			height: 65%;
			font-size: 1.7em;
		}
	}
`;

export const RibbonText = styled.div`
	position: relative;
	top: -6%;
`;

export const Items = styled.div`
	justify-content: space-evenly;
	position: relative;
	top: -1%;
	align-items: center;
	display: flex;
	width: 100%;
	height: 40%;

	&.several-nodes {
		top: -5%;
		height: 45%;
	}

	@media (min-width: 734px) {
		top: unset;
		width: unset;
		height: 32%;

		&.several-nodes {
			top: unset;
			height: 32%;
		}
	}
`;
interface IRewardItem {
	width?: string;
	filter?: number;
}
export const RewardItem = styled.div<IRewardItem>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	padding: 0.1em;
	filter: grayscale(${(props) => props.filter});

	@media (min-width: 734px) {
		flex-basis: ${(props) => props.width};
	}
`;

export const RewardAmount = styled(Typography)`
	color: #fff;
	font-weight: 700;
	font-size: 1.4em;
	-webkit-text-stroke-width: 0.24em;
	-webkit-text-stroke-color: #333;
	&.several-nodes {
		font-size: 1.2em;
	}

	@media (min-width: 734px) {
		font-size: 1.4em;
		&.several-nodes {
			font-size: 1.4em;
		}
	}
`;

export const ItemImage = styled.img`
	width: 4.3em;
	height: 4.3em;
	object-fit: contain;
	justify-self: center;
	align-self: center;

	&.several-nodes {
		width: 3.8em;
		height: 3.8em;
	}

	@media (min-width: 734px) {
		width: 5.5em;
		height: 5.5em;
		&.several-nodes {
			width: 4em;
			height: 4em;
		}
	}
`;

export const InfoBox = styled(Box)`
	align-items: center;
	background-color: rgb(0 0 0 / 30%);
	border-radius: 999em;
	color: white;
	display: flex;
	flex-direction: row;
	font-weight: 220;
	opacity: 0.9;
	padding: 0.15em 0.4em;
	background-repeat: no-repeat;

	@media (min-width: 734px) {
		padding: 0 0.4em;
		&.several-nodes {
			padding: 0 0.4em;
		}
	}
`;

export const LoyalBox = styled(InfoBox)`
	background-position: 90% center;
	color: white;
	background: rgba(0, 0, 0, 0.51);
	white-space: nowrap;
	font-size: 1.5em;
	svg,
	img {
		padding-left: 0.1em;
		width: 1.13em;
	}

	&.several-nodes {
		font-size: 1.2em;
	}

	@media (min-width: 734px) {
		font-size: 1.2em;
		&.several-nodes {
			font-size: 1.2em;
		}
	}
`;

export const StyledLoyaltyPoints = styled(LoyaltyPointsV2)`
	border-radius: 1.33em;
	border-width: 0.08em;
	box-shadow: 0 0 0.83em 0 rgba(68, 200, 223, 0.95) inset;
	font-size: 3em;
	padding: 0.17em 0.5em;

	> div {
		gap: 0.25em;
	}
`;

export const LoyalBoxWrap = styled(Box)`
	position: relative;
	display: flex;
	align-items: center;
	font-size: 0.45em;
	justify-content: center;
	height: 15%;

	&.several-nodes {
		//position: absolute;
		top: -3.4em;
	}

	@media (min-width: 734px) {
		//position: absolute;
		//top: 3%;
		height: 14%;
		&.several-nodes {
			height: 15%;
			top: -0.3em;
		}
	}
`;

export const StyledButton = styled(Button)`
	position: relative;
	border-radius: 0.53em !important;
	width: 8em;
	height: 55%;
	font-size: 1.5em;

	&.several-nodes {
		top: -0.9em;
		height: 15%;
	}

	@media (min-width: 734px) {
		border-radius: 0.73em !important;
		width: 10em;
		max-width: 138px;
		font-size: 1.5em;
		height: 18%;
		//top: 4%;

		&.several-nodes {
			top: unset;
			height: 18%;
			//width: 8.33em;
		}
	}
`;

export const LockImage = styled.img`
	height: 100%;
	position: absolute;
	right: -5%;
	object-fit: contain;
`;

export const AnimatedNodeSlot = styled(animated.div)`
	position: relative;
	width: 100%;
	height: 100%;
	min-width: 0;
	min-height: 0;
`;

export const AnimatedLayoutNodeSlot = styled(motion.div)`
	position: relative;
	width: 100%;
	height: 100%;
	min-width: 0;
	min-height: 0;
`;
